// Content registry — pure re-exporter from the single source of truth.
// All portfolio content lives in /src/data/profile.json.
// This file exists only to keep existing import paths across components.
// Refactored per emergent-portfolio-master-v3 §3.1: Feb 14, 2026.

import profile from "../../data/profile.json";

export const PROFILE = profile;

export const HERO = {
  headline: profile.identity.headline,
  subline: profile.identity.subline,
  cta: "Explore further",
};

export const SUMMARY_HUB = profile.summary;

export const STATS = [
  { value: 15,   suffix: "+", label: "years professional experience" },
  { value: 10,   suffix: "",  label: "years entrepreneurship" },
  { value: 5,    suffix: "",  label: "years corporate / intrapreneurship" },
  { value: 2000, suffix: "+", label: "learners trained" },
  { value: 300,  suffix: "+", label: "clients served" },
  { value: 5000, suffix: "+", label: "stakeholders impacted" },
  { value: 15,   suffix: "+", label: "industries served" },
];

export const CREDIBILITY = profile.trustedBy;
export const SUMMARY_BULLETS = profile.summaryBullets;
export const IMPACT_TILES = profile.impactTiles;

// -------- Path cases (rendered from profile.json) --------

function toCaseCard(cs, fallbackEyebrow) {
  if (cs.placeholder) {
    return {
      eyebrow: fallbackEyebrow || "Design",
      title: cs.placeholder,
      challenge: "Case study coming soon.",
      didWhat: "",
      impactBullets: [],
      metric: "",
      isPlaceholder: true,
    };
  }
  return {
    eyebrow: cs.client,
    title: cs.context || cs.client,
    challenge: cs.challenge,
    didWhat: cs.action,
    impactBullets: cs.impactBullets || [],
    metric: cs.metric,
    headline: cs.headline,
  };
}

const EXPERIENCE_CASES = (profile.caseStudies.experience || []).map((c) => toCaseCard(c));
const BUSINESS_CASES = profile.caseStudies.businessImpact.map((c) => toCaseCard(c));
const AI_CASES = profile.caseStudies.aiReadiness.map((c) => toCaseCard(c));
const DESIGN_CASES = profile.caseStudies.design.map((c) => toCaseCard(c, "Design"));

export const PATHS = [
  { id: "impact",     label: "Impact",           accent: "warm",
    intro: "The whole gist, on one page.",
    kind: "impact" },
  { id: "ai",         label: "AI Portfolio",     accent: "blue",
    intro: "$5,000+ self-invested. Here is what I have built and some hand-picked case studies.",
    kind: "ai-portfolio",
    cases: AI_CASES },
  { id: "design",     label: "Design Portfolio", accent: "ink",
    intro: "Selected design work and some hand-picked case studies.",
    kind: "design-portfolio",
    cases: DESIGN_CASES },
  { id: "business",   label: "Growth Stories",   accent: "mint",
    intro: "Where design thinking and execution have moved revenue, adoption, or efficiency. Here are some hand-picked case studies.",
    cases: BUSINESS_CASES },
  { id: "skills",     label: "Skills",                accent: "mint",
    intro: "Core competencies, tools & fluency levels.",
    kind: "skills" },
  { id: "experience", label: "Experience",       accent: "wood",
    intro: "A decade building creative studios, five years inside a global enterprise.",
    cases: EXPERIENCE_CASES },
  { id: "education",  label: "Education",             accent: "wood",
    intro: "Formal foundations plus continuous upskilling.",
    kind: "education" },
  { id: "leadership", label: "Exposure & Social Impact", accent: "blue",
    intro: "Global perspective, community impact and mentorship — the lens shaped by 15+ years across boardrooms, classrooms and global summits.",
    kind: "leadership" },
  { id: "more",       label: "More",             accent: "warm",
    intro: "Press, gallery, blog, testimonials, and how to reach me." },
];

// Sub-sections inside the "More" accordion row
export const MORE_SUBSECTIONS = profile.moreSubsections;

export const CLOSE = {
  line: profile.close.line,
  email: profile.close.email,
  linkedin: profile.close.linkedin,
  resume: profile.close.resumeHref,
};
